import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import RoomDetails from '../Common/RoomDetails'

import FoldableContent from 'components/Common/FoldableContent/FoldableContent'
import { BaseImage } from 'components/Common/OrderView/styles'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'

interface Prop {
  offer: App.Offer
  order: App.Order
}

const ReservedFor = styled.div`
  display: flex;
  flex-direction: column;
`

const BookingDetails = styled.div`
  padding: ${rem(20)} 0;
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutral.six};
`

function LeOfferPackageSummary({ offer, order }: Prop) {
  const pkg = (orderItem: App.OrderItem) =>
    offer &&
    orderItem &&
    offer?.packages &&
    offer.packages.length > 0 &&
    offer.packages.find((p) => p.uniqueKey === orderItem.package.uniqueKey)

  const getImage = (orderPackage: App.Package) => {
    if (
      orderPackage?.roomType?.images &&
      orderPackage.roomType.images.length > 0
    ) {
      return orderPackage.roomType.images[0].id
    }
    if (offer?.image?.id) {
      return offer.image.id
    }
  }

  return (
    <>
      {order?.items?.map((orderItem) => {
        const orderPackage = pkg(orderItem)
        const imageId = orderPackage && getImage(orderPackage)

        return (
          orderItem?.reservation && (
            <BookingDetails key={orderItem.id}>
              <Heading variant="heading5">Your Package</Heading>
              {imageId && (
                <BaseImage
                  className="hidden-print"
                  id={imageId}
                  mobileAspectRatio="9:4"
                  mobileWidth="100"
                />
              )}
              {orderItem.package.name ||
                (orderItem?.reservation.roomType && (
                  <div>
                    {orderItem.package.name && (
                      <BodyText variant="medium" weight="semi-bold">
                        {orderItem.package.name}
                      </BodyText>
                    )}
                    {orderItem?.reservation.roomType && (
                      <BodyText variant="medium">
                        {orderItem?.reservation.roomType.name}
                      </BodyText>
                    )}
                  </div>
                ))}
              {orderItem?.reservation && (
                <ReservedFor>
                  <BodyText variant="medium" weight="semi-bold">
                    Reserved for
                  </BodyText>
                  {/* ToDo: Do this in a cleaner way */}
                  <BodyText variant="large">{`${orderItem?.reservation.guestFirstName} ${orderItem?.reservation.guestLastName}, ${orderItem?.reservation.adults} adults`}</BodyText>
                </ReservedFor>
              )}
              {orderPackage && (
                <FoldableContent
                  openLabel="Hide package and room details"
                  closedLabel="View package and room details"
                >
                  <RoomDetails pkg={orderPackage} />
                </FoldableContent>
              )}
            </BookingDetails>
          )
        )
      })}
    </>
  )
}

export default LeOfferPackageSummary
